import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import { Login } from './Components/Login/Login'
import { Home } from './Components/Home/Home'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from './store/store'
import Navbar from './Components/Navbar/Navbar'
import { Logout } from './Components/Logout/Logout'
import { ProtectedRoute } from './Components/ProtectedRoutes/ProtectedRoute'
import { CatClientes } from './Components/Catalogos/CatClientes'
import { CatProveedores } from './Components/Catalogos/CatProveedores'
import { CatTipoUnidades } from './Components/Catalogos/CatTipoUnidades'
import { CatUbicaciones } from './Components/Catalogos/CatUbicaciones'
import { CatRutas } from './Components/Catalogos/CatRutas'
import { OpMonitor } from './Components/Operaciones/OpMonitor'
import { CatServicios } from './Components/Catalogos/CatServicios'
import { CatUsuarios } from './Components/Catalogos/CatUsuarios'
import { ResetAccount } from './Components/ResetAccount/ResetAccount'

function App() {
  const UserLogued = useSelector(
    (state: RootState) => state.UserProfile.UserProfile.logueado
  )

  /*   useEffect(() => {
    console.log('Entro al proceso de router ' + UserLogued)
  }, [UserLogued]) */

  function PageNotFound() {
    return (
      <div>
        <h2>Sorry, no matching page</h2>
      </div>
    )
  }

  return (
    <div className='App'>
      <HashRouter>
        <Navbar />
        <Routes>
          {/*   <Route path='/' element={<Home />}></Route>
          <Route path='login' element={<Login />}></Route> */}
          <Route path='/' element={<Login />}></Route>
          <Route path='/logout' element={<Logout />}></Route>
          <Route path='/reset' element={<ResetAccount />}></Route>
          <Route element={<ProtectedRoute />}>
            <Route path='/OpMonitor' element={<OpMonitor />} />
            <Route path='/CatClientes' element={<CatClientes />} />
            <Route path='/CatServicios' element={<CatServicios />} />
            <Route path='/CatProveedores' element={<CatProveedores />} />
            <Route path='/CatTipoUnidades' element={<CatTipoUnidades />} />
            <Route path='/CatUbicaciones' element={<CatUbicaciones />} />
            <Route path='/CatRutas' element={<CatRutas />} />
            <Route path='/CatUsuarios' element={<CatUsuarios />} />
          </Route>
          <Route path='*' element={<PageNotFound />} />
        </Routes>
      </HashRouter>
    </div>
  )
}

export default App
